module.exports = __webpack_public_path__ + "static/media/client-background.4cc94eb6.jpg";